export default {
  name: {
    date: "Date",
    price: "Price",
  },
};
